import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "../../hooks/useTranslation";
import styled from "styled-components";

const QuickActions = ({ variant = "admin" }) => {
  const { translate } = useTranslation();
  const navigate = useNavigate();

  const adminActions = [
    {
      icon: "👥",
      text: translate("quickActions.manageClients"),
      action: () => navigate("/clients-list"),
    },
    {
      icon: "💰",
      text: translate("quickActions.manageDeposits"),
      action: () => navigate("/deposit-admin"),
    },
    {
      icon: "💸",
      text: translate("quickActions.manageWithdraws"),
      action: () => navigate("/withdraw-admin"),
    },
    {
      icon: "₿",
      text: translate("quickActions.manageCrypto"),
      action: () => navigate("/crypto-admin"),
    },
    {
      icon: "📈",
      text: translate("quickActions.createProject"),
      action: () => navigate("/create-project"),
    },
    {
      icon: "📊",
      text: translate("quickActions.viewProjects"),
      action: () => navigate("/projects"),
    },
  ];

  const clientDetailsActions = [
    {
      icon: "💰",
      text: translate("quickActions.manageDeposits"),
      action: () => navigate("/deposit-admin"),
    },
    {
      icon: "💸",
      text: translate("quickActions.manageWithdraws"),
      action: () => navigate("/withdraw-admin"),
    },
    {
      icon: "₿",
      text: translate("quickActions.manageCrypto"),
      action: () => navigate("/crypto-admin"),
    },
    {
      icon: "👥",
      text: translate("quickActions.backToClients"),
      action: () => navigate("/dashboard-admin"),
    },
  ];

  const actions = variant === "clientDetails" ? clientDetailsActions : adminActions;

  return (
    <QuickActionsSection>
      <QuickActionsTitle>
        {translate(`quickActions.${variant}.title`)}
      </QuickActionsTitle>
      <QuickActionsGrid>
        {actions.map((action, index) => (
          <QuickActionButton key={index} onClick={action.action}>
            <QuickActionIcon>{action.icon}</QuickActionIcon>
            <QuickActionText>{action.text}</QuickActionText>
          </QuickActionButton>
        ))}
      </QuickActionsGrid>
    </QuickActionsSection>
  );
};

// Styled Components
const QuickActionsSection = styled.div`
  background-color: #1a1a1a;
  border-radius: 12px;
  padding: 30px;
  margin-bottom: 30px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border: 1px solid #333;
`;

const QuickActionsTitle = styled.h3`
  color: #c09c5c;
  font-size: 20px;
  margin: 0 0 25px 0;
  text-align: center;
  font-weight: 600;
`;

const QuickActionsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  
  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 15px;
  }
`;

const QuickActionButton = styled.button`
  background: linear-gradient(135deg, #2a2a2a, #1a1a1a);
  border: 1px solid #c09c5c;
  border-radius: 12px;
  padding: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  min-height: 120px;
  justify-content: center;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 25px rgba(192, 156, 92, 0.3);
    background: linear-gradient(135deg, #a07c4b, #8a6b3f);
    border-color: #a07c4b;
  }

  &:active {
    transform: translateY(-2px);
  }

  @media (max-width: 768px) {
    padding: 15px;
    min-height: 100px;
    gap: 8px;
  }
`;

const QuickActionIcon = styled.div`
  font-size: 32px;
  margin-bottom: 8px;
  
  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

const QuickActionText = styled.span`
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  line-height: 1.3;
  
  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

export default QuickActions;
